module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h13"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('img', {
    attrs: {
      "alt": "img5.png",
      "src": "Images/img5.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', [_vm._v("Thank you for all you’ve done Jody, Tali, Cia, and Julie.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dfb4e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007.vue
// module id = 72
// module chunks = 0